<template>
    <div>
        <h2>Импорт компаний</h2>
        <tsoft-import-data></tsoft-import-data>
    </div>
</template>

<script>

    import tsoftImportData from "../components/imports/ImportData.vue";

    export default {

        components: {
            "tsoft-import-data": tsoftImportData,

        },
    }

</script>
